<section class="page-card">
  <app-back-button-component />

  <div class="section-kicker">Guild Registry</div>
  <h2 class="section-title">Users</h2>
  <p class="empty-copy">
    Members of the codex are listed here like a guild ledger, with their handles and station in the
    campaign.
  </p>

  @if (isLoadingUsers()) {
    <app-loading-component
      [title]="'Calling The Guild'"
      [message]="'Loading users from the backend.'"
    />
  } @else if (loadUsersError) {
    <p>{{ loadUsersError }}</p>
  } @else if (users() && users().length > 0) {
    <div class="user-roster">
      @for (user of users(); track user.id) {
        <article class="user-card">
          <div class="user-card-header">
            <div>
              <div class="user-kicker">@{{ user.username }}</div>
              <h3>{{ user.name }}</h3>
            </div>
            <div class="user-id">{{ user.name }}</div>
          </div>

          <div class="user-card-body">
            <p><strong>Email:</strong> {{ user.email }}</p>

            @if (user.roles.length > 0) {
              <div class="role-row">
                @for (role of user.roles; track role) {
                  <span class="role-badge">{{ role }}</span>
                }
              </div>
            } @else {
              <p class="role-empty">No role assigned</p>
            }
          </div>
        </article>
      }
    </div>
  } @else {
    <p>No users found</p>
  }
</section>
